var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWPlash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9773 7.58461L21.976 7.58227C20.0802 3.98035 19.5587 3.49755 15.297 2.99078L15.2961 2.99065C11.6296 2.55474 10.3033 4.58364 10.0033 5.16067C4.94626 15.8453 -5.56083 37.4036 -17.0602 57.205C-2.73629 39.4385 13.5698 21.9674 21.7631 13.3893C22.6948 12.4111 23.8518 11.1465 21.9773 7.58461Z",
    fill: "#F2D422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3196 7.44053C13.6195 6.86339 14.946 4.8346 18.6124 5.27051L18.6133 5.27063C19.5169 5.37812 20.251 5.48474 20.8671 5.6201C19.6681 3.76634 18.6184 3.38549 15.2971 2.99056L15.2962 2.99043C11.6298 2.55452 10.3035 4.58342 10.0034 5.16045C4.94641 15.8451 -5.56069 37.4034 -17.0601 57.2048C-12.6576 51.7441 -8.06797 46.3118 -3.58413 41.1568C3.6809 27.4964 9.81172 14.852 13.3196 7.44053Z",
    fill: "#E8C018"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWPlash);
export default __webpack_public_path__ + "static/media/w-plash.37c7c0df3b6d31827febde7b7b54a1ef.svg";
export { ForwardRef as ReactComponent };